<template>
  <div class="Managers">
    <block-title
      title="Managers"
      :can-edit="hasAdminRights"
      :modal-to-edit="Modal.USER_LIST"
    />
    <ul class="Managers-list">
      <li v-for="id in list" :key="id" class="Manager">
        <user-info :id="id" />
      </li>
    </ul>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {Modal} from '@/lib/definitions'
import UserInfo from '@/components/landscape/topics/UserInfo'
import BlockTitle from './BlockTitle'

export default {
  name: 'Managers',
  components: {
    BlockTitle,
    UserInfo
  },
  props: {
    list: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  data() {
    return {
      Modal
    }
  },
  computed: {
    ...mapGetters(['hasAdminRights'])
  }
}
</script>

<style>
.Managers {
  &-list {
    margin: 0;
    padding: 0;
    display: block;
    .Manager {
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
